import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import { useEffect, useState } from "react";
import puffuIcon from "resources/img/puffu/puffuIcon.png";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import Container from "layouts/container/Container";
import Dummy from "components/Dummy";

function PaymentCompleteSuccess() {
    const [visible, setVisible] = useState(true);
    
    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        
        // 웹뷰 감지 로직
        const isWebView = (() => {
            const isIOSWebView = /(iphone|ipod|ipad).*applewebkit(?!.*safari)/i.test(userAgent);
            const isAndroidWebView = /wv/.test(userAgent) || /android.*samsungbrowser\/(?!.*chrome)/i.test(userAgent);
            
            return isIOSWebView || isAndroidWebView;
        })();
        
        setVisible(isWebView);
    }, []);
    
    const onClick = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        
        // 웹뷰 감지 로직
        const isWebView = (() => {
            const isIOSWebView = /(iphone|ipod|ipad).*applewebkit(?!.*safari)/i.test(userAgent);
            const isAndroidWebView = /wv/.test(userAgent) || /android.*samsungbrowser\/(?!.*chrome)/i.test(userAgent);
            
            return isIOSWebView || isAndroidWebView;
        })();
        
        if (isWebView) {
            if (window.BRIDGE && typeof window.BRIDGE.closeWebView === "function") {
                window.BRIDGE.closeWebView();
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.BRIDGE) {
                window.webkit.messageHandlers.BRIDGE.postMessage('closeWebView');
            }
        } else {
            // alert("웹뷰아님");
            try {
                window.close();
            } catch (error) {
                alert('브라우저에서 창을 닫을 수 없습니다.');
            }
        }
    }
    
    const btnStyle = {
        width: "90%",
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "48px"
    }
    
    return (
        <Container height={"85vh"}>
            <VerticalFlex>
                <FlexChild justifyContent={"flex-end"}>
                    {/* <img src={puffuIcon} /> */}
                    <Dummy height={"15px"} />
                    <P size={"7vw"} font={"GmarketSansBold"} color={"var(--main-color)"}>결제완료!</P>
                    <Dummy height={"15px"} />
                    <P size={18} weight={"bold"}>결제가 정상적으로 완료되었습니다.</P>
                </FlexChild>
                <FlexChild justifyContent={"flex-end"}>
                    {
                        visible &&
                        <CustomButton style={btnStyle} onClick={onClick} text={"돌아가기"} />
                    }
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
} export default PaymentCompleteSuccess;